<template>
  <div>
    <HseModalForm v-model="isOpen" :title="$t(modalTitle)">
      <div class='big-item'>
        <!-- Этап 1: Выбор статуса -->
        <Validator v-bind:field="fields.StatusSelect" v-if="showStatusSelect" @change="checkStatus" />

        <!-- Этап 2: Предупреждение для отклонения -->
        <div v-if="showRejectWarning">
          <HseParagraph :hasMargin="true">
            Вы планируете отклонить заявку до экспертизы. Это означает, что работа с данной заявкой будет завершена и
            заявителю будет направлен Ваш комментарий с причинами отклонения.
            Если заявка соответствует тематике другой секции, Вы можете изменить окончательную секцию, в рамках которой
            заявка будет рассмотрена.
          </HseParagraph>
        </div>

        <!-- Этап 3: Ввод комментария -->
        <div v-if="showCommentInput">
          <Validator v-bind:field="fields.comment" :readonly="this.isTextVerification" />
        </div>

        <HseSpace size='small_2x' vertical />
      </div>
      <div class="actions">
        <!-- Кнопка отмены для этапа ввода комментария -->
        <HseButton v-if="showCommentInput && this.fields.StatusSelect.value != '26221A69-FE87-4A64-8D98-080B02C04169'"
          @click="cancel">
          {{ $t('cancel') }}
        </HseButton>

        <!-- Кнопки для этапа выбора статуса -->
        <div v-if="showStatusSelect && !isRejectStatus">
          <HseButton :spinner="isLoading" @click="send">
            {{ $t('send') }}
          </HseButton>
        </div>

        <!-- Кнопки для этапа предупреждения отклонения -->
        <div v-else-if="showRejectWarning" class="actions_buttons">
          <HseButton variant='secondary' @click="backToStatusSelection">
            {{ $t('backToReview') }}
          </HseButton>
          <HseButton @click="proceedToComment">
            {{ $t('reject') }}
          </HseButton>
        </div>

        <!-- Кнопки для этапа ввода комментария отклонения -->
        <div v-else-if="showCommentInput && isRejectStatus" class="actions_buttons">
          <HseButton variant='secondary' @click="backToWarning">
            {{ $t('back') }}
          </HseButton>
          <HseButton :spinner="isLoading" @click="reject">
            {{ $t('reject') }}
          </HseButton>
        </div>

        <!-- Кнопки для других статусов с комментарием -->
        <div v-else-if="showCommentInput && !isRejectStatus">
          <HseButton :spinner="isLoading" @click="send">
            {{ $t('send') }}
          </HseButton>
        </div>
      </div>
    </HseModalForm>
  </div>
</template>

<script>

import { HseModalForm, HseButton, HseSpace, HseParagraph } from '@hse-design/vue'
import Validator from '../common/form/Validator.vue'
import fields from './managerFields'
import { mapState } from 'vuex'
import { localizeFields } from '../../i18n'

export default {
  props: [
    'commentMessage'
  ],
  components: {
    HseModalForm,
    HseButton,
    HseSpace,
    Validator,
    HseParagraph
  },
  data: () => ({
    isOpen: false,
    isLoading: false,
    isTextVerification: false,
    showRejectWarning: false,
    showCommentInput: false,
    fields,
    rejectStatusId: '26221A69-FE87-4A64-8D98-080B02C04169',
    reworkStatusId: '96F18960-F327-419C-B1FA-D4CFA3FD5103'
  }),
  created() {
    this.translateFields()
    this.$parent.$on('openStatusModal', () => { this.isOpen = true })
  },
  methods: {
    send() {
      // Для статуса "На доработку" - проверяем комментарий
      if (this.fields.StatusSelect.value === this.reworkStatusId) {
        this.$root.$refs.validator.validationInModal()
        if (this.fields.comment.isValid) {
          this.submitStatus()
        }
      } else {
        // Для статусов без комментария
        this.submitStatus()
      }
    },

    // Переход к вводу комментария для отклонения
    proceedToComment() {
      this.showRejectWarning = false
      this.showCommentInput = true
    },

    // Назад к предупреждению
    backToWarning() {
      this.showRejectWarning = true
      this.showCommentInput = false
    },

    // Назад к выбору статуса
    backToStatusSelection() {
      this.showRejectWarning = false
      this.showCommentInput = false
      this.isTextVerification = false
      this.isOpen = false
    },

    reject() {
      // Проверяем валидность комментария перед отклонением
      this.$root.$refs.validator.validationInModal()
      if (this.fields.comment.isValid) {
        this.submitStatus()
      }
    },

    submitStatus() {
      this.isLoading = true;

      // Формируем данные для отправки в зависимости от статуса
      if (this.isRejectStatus || this.fields.StatusSelect.value === this.reworkStatusId) {
        this.$emit('openStatusModalResponse', this.fields.StatusSelect.value, this.fields.comment.value)
      } else {
        this.$emit('openStatusModalResponse', this.fields.StatusSelect.value)
      }

      setTimeout(() => {
        this.isOpen = false;
        this.isLoading = false;
        this.resetModalState();
      }, 200);
    },

    cancel() {
      this.showCommentInput = false
      this.isTextVerification = false
    },

    cancelModal() {
      this.isOpen = false
      this.resetModalState()
    },

    resetModalState() {
      this.isTextVerification = false
      this.showRejectWarning = false
      this.showCommentInput = false
      this.fields.StatusSelect.value = ''
      this.fields.comment.value = null
    },

    translateFields() {
      this.fields = localizeFields(fields, this.fields)
    },

    checkStatus(value) {
      console.log('checkStatus', value)

      // Для статуса "Отклонено" - показываем предупреждение
      if (value === this.rejectStatusId) {
        this.fields.comment.value = this.commentMessage
        this.showRejectWarning = true
      }
      // Для статуса "На доработку" - сразу показываем поле комментария
      else if (value === this.reworkStatusId) {
        this.showCommentInput = true
        this.fields.comment.value = null
      }
      else {
        this.fields.comment.value = null
        this.showRejectWarning = false
        this.showCommentInput = false
      }
    }
  },
  computed: {
    ...mapState(['lang']),

    isRejectStatus() {
      return this.fields.StatusSelect.value === this.rejectStatusId
    },

    showStatusSelect() {
      return !this.showRejectWarning && !this.showCommentInput
    },

    modalTitle() {
      if (this.showRejectWarning) {
        return 'rejectWarning'
      } else if (this.showCommentInput) {
        return 'enterComment'
      } else {
        return 'select'
      }
    }
  },
  watch: {
    lang() {
      this.translateFields()
    },
    isOpen() {
      this.resetModalState()
    },
  },
  i18n: {
    messages: {
      en: {
        send: 'Send',
        select: 'Select a status',
        checkText: 'Check the text of the letter',
        cancel: 'Cancel',
        reject: 'Reject',
        backToReview: 'Back to review',
        back: 'Back',
        rejectWarning: 'Rejection warning',
        enterComment: 'Enter comment'
      },
      ru: {
        backToReview: 'Вернуться к рассмотрению',
        back: 'Назад',
        reject: 'Отклонить',
        send: 'Отправить',
        select: 'Выберите статус',
        checkText: 'Проверьте текст письма',
        cancel: 'Отмена',
        rejectWarning: 'Предупреждение об отклонении',
        enterComment: 'Введите комментарий',
        textTooltip: 'Можно оставить один из предложенных вариантов текста уведомления (развернуть поле Комментарий можно потянув за правый нижний угол) или заменить на свой. Текст письмо носит рекомендательный характер. Рекомендуется письмо-отказ подписать.',
      },
    }
  }
}
</script>

<style scoped>
.event-card {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 32px;
  max-width: 800px;
  margin: 52px auto;
}

.actions_buttons {
  display: flex;
  gap: 20px;
}

.big-item {
  min-height: 400px;
}

.link {
  white-space: nowrap;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.two-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.three-cols {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
}

.prepull {
  overflow: auto;
}

.pull-right {
  float: right;
}

.actions {
  flex-wrap: wrap;
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-end;
}
</style>